// API Configuration
// This file centralizes all API configuration to easily switch between environments

const isDevelopment = process.env.NODE_ENV === 'development';
const isProduction = process.env.NODE_ENV === 'production';

// API base URLs
export const API_CONFIG = {
  // Use environment variable if set, otherwise use defaults based on environment
  baseURL: process.env.REACT_APP_API_URL || (isProduction 
    ? 'https://api.pravnickai.cz/api/v1'
    : 'http://localhost:8000/api/v1'
  ),
  
  // Timeout for API requests (in milliseconds)
  timeout: 120000,
  
  // Whether to include credentials in requests
  withCredentials: false,
};

// Helper to get base URL without /api/v1 suffix (for file downloads)
export const getBaseURL = () => {
  return API_CONFIG.baseURL.replace('/api/v1', '');
};

// Helper to get full URL for a given path
export const getFullURL = (path: string) => {
  const baseURL = getBaseURL();
  return `${baseURL}${path}`;
};

export default API_CONFIG;